export const toPriceFormat = intPrice => {
  return new Intl.NumberFormat('en-EN', {
    style: 'currency',
    currency: 'USD'
  }).format(intPrice);
};

export default toPriceFormat;
